<template>
  <DefaultLayout>
    <div>
      <trainer-details></trainer-details>
    </div>
  </DefaultLayout>
</template>

<script>
import TrainerDetails from '../components/trainers/TrainerDetails.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'

export default {
  components: {
    DefaultLayout,
    TrainerDetails
  }
}
</script>
